import { clsx, type ClassValue } from 'clsx'
import { twMerge } from 'tailwind-merge'

/**
 * Combines class names and resolves Tailwind conflicts.
 * `cn('px-4', isLarge && 'px-6')` → `'px-6'` (later class wins for same property).
 * Preferred over template literals and raw clsx for any Tailwind-heavy component.
 */
export const cn = (...inputs: ClassValue[]) => twMerge(clsx(inputs))
